import { NullState } from '@mi-front/ui';
import { useQueryClient } from '@tanstack/react-query';
import { FormattedMessage } from 'react-intl';
import { useFragmentQuery } from '../../../../../hooks/useFragment';
import { Fragment } from '../../../../../types';
import { TranscriptionStart } from '../actions/TranscriptionStart';

interface Props {
  readonly fragment: Fragment;
}

export function NoTranscription({ fragment }: Props) {
  const queryClient = useQueryClient();

  return (
    <NullState className="p-6">
      <div className="mb-4">
        <FormattedMessage
          id="fragments.transcriptionView.noTranscription"
          defaultMessage="Este fragmento no ha sido transcripto aún"
        />
      </div>
      <TranscriptionStart
        fragment={fragment}
        onStarted={() =>
          queryClient.invalidateQueries({
            queryKey: useFragmentQuery.queryKey(fragment.id),
          })
        }
      />
    </NullState>
  );
}
